"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PionexLiteSupportAreaCodeList2 = exports.PionexLiteSupportAreaCodeList1 = void 0;
exports.PionexLiteSupportAreaCodeList1 = [
    "USA",
    "HKG",
    "MAC",
    "TWN",
    "SGP",
];
exports.PionexLiteSupportAreaCodeList2 = [
    "DZA",
    "AND",
    "ATA",
    "ATG",
    "ARG",
    "ARM",
    "ABW",
    "AUS",
    "AUT",
    "AZE",
    "BHR",
    "BGD",
    "BRB",
    "BLR",
    "BEL",
    "BEN",
    "BOL",
    "BIH",
    "BWA",
    "BRA",
    "BRN",
    "BGR",
    "BFA",
    "KHM",
    "CMR",
    "CAN",
    "CPV",
    "CHL",
    "CCK",
    "COL",
    "COM",
    "COG",
    "CRI",
    "CIV",
    "HRV",
    "CYP",
    "CZE",
    "DNK",
    "DJI",
    "DMA",
    "COD",
    "ECU",
    "EGY",
    "ERI",
    "EST",
    "ETH",
    "FRO",
    "FJI",
    "FIN",
    "FRA",
    "GAB",
    "GEO",
    "DEU",
    "GHA",
    "GIB",
    "GRC",
    "GIN",
    "GNB",
    "HUN",
    "ISL",
    "IND",
    "IDN",
    "IRL",
    "ISR",
    "ITA",
    "JAM",
    "JPN",
    "KAZ",
    "KOR",
    "LAO",
    "MDG",
    "MYS",
    "MDV",
    "MLT",
    "MRT",
    "MUS",
    "MEX",
    "FSM",
    "MNG",
    "MAR",
    "MMR",
    "NPL",
    "NLD",
    "ANT",
    "NZL",
    "NIC",
    "NGA",
    "NOR",
    "PAK",
    "PAN",
    "PER",
    "PHL",
    "POL",
    "PRT",
    "ROU",
    "RUS",
    "RWA",
    "SAU",
    "SCO",
    "ZAF",
    "ESP",
    "LKA",
    "SWE",
    "CHE",
    "THA",
    "TUR",
    "UGA",
    "UKR",
    "ARE",
    "GBR",
    "URY",
    "VNM",
    "ZMB",
    "ZWE",
];
